var r=(t=>(t[t.Off=99]="Off",t[t.Trace=0]="Trace",t[t.Debug=1]="Debug",t[t.Info=2]="Info",t[t.Warn=3]="Warn",t[t.Error=4]="Error",t))(r||{}),n="logger-message-event";export{n as EventType,r as Level};
